/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
const menuItem = {
  styleOverrides: {
    root: {
      minWidth: 160,
      minHeight: 36,
      padding: "0 var(--space-3, 12px)",
      borderRadius: "var(--radius-sm, 6px)",
      fontFamily: "var(--font-family-primary, 'Lexend', sans-serif)",
      fontSize: "var(--font-size-body-sm, 14px)",
      color: "var(--text-primary, #142624)",
      transition:
        "background-color var(--duration-fast, 150ms) var(--easing-standard, ease), color var(--duration-fast, 150ms) var(--easing-standard, ease)",

      "&:hover, &:focus, &.Mui-selected, &.Mui-selected:hover, &.Mui-selected:focus":
        {
          backgroundColor: "var(--interactive-soft, #f0f8f7)",
          color: "var(--interactive-default, #0f766e)",
        },
      "&.Mui-disabled": { color: "var(--text-disabled, #8a9896)", opacity: 1 },
    },
  },
};

export default menuItem;
